import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--prevent-action"
export default class extends Controller {
  connect() {}

  block(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}
